// React
import React from 'react';
// External libraries
import { Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// Internal
import getFormFieldVal from 'utils/getFormFieldVal';

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            verificationCode: '',
            errors: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        const fieldObj = getFormFieldVal(event);
        this.setState((prevState) => {
            if (prevState.errors.length) {
                const { errors } = prevState;
                const errorIndex = errors.indexOf(event.target.name);
                if (errorIndex >= 0) {
                    errors.splice(errorIndex, 1);
                }

                return { ...fieldObj, errors };
            }
            return { ...fieldObj };
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const errorList = [];
        // Check non empty field
        if (!this.state.verificationCode) {
            errorList.push('verificationCode');
        }

        this.setState({ errors: errorList });
        if (errorList.length > 0) {
            return false;
        }

        // Code verify is send to the main form to set the new password
        this.props.onSubmit(this.state.verificationCode);
    }

    hasError(key) {
        return this.state.errors.indexOf(key) !== -1;
    }

    render() {
        return (
            <div>
                <Form>
                    <Form.Group controlId="verificationCode" className="control-group">
                        <Form.Label>Verification Code</Form.Label>
                        <Form.Control
                            className={this.hasError('verificationCode') ? 'is-invalid' : ''}
                            name="verificationCode"
                            value={this.state.verificationCode}
                            onChange={this.handleInputChange}
                            type="text"
                            placeholder="Enter verification code"
                        />
                        <Form.Control.Feedback
                            type="invalid"
                            className={
                                this.hasError('verificationCode') ? 'invalid-feedback' : 'hidden'
                            }
                        >
                            The verification code is invalid
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Button className="login-button" onClick={this.handleSubmit} type="submit">
                        Submit
                    </Button>
                </Form>
                <div className="link-wrapper">
                    <Link
                        className="link"
                        to={{
                            pathname: '/login',
                            search: this.state.email ? `?email=${this.state.email}` : null
                        }}
                    >
                        Return to login
                    </Link>
                </div>
            </div>
        );
    }
}

export default ForgotPassword;
